var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 26.6 1.68 28.8 4 29.64V36H0V40H12V36H8V29.64C10.32 28.8 12 26.6 12 24V8H0V24ZM4 12H8V18H4V12Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.26 13.08L33.36 12.44C32.56 12.18 32 11.42 32 10.56V2C32 0.9 31.1 0 30 0H24C22.9 0 22 0.9 22 2V10.56C22 11.42 21.44 12.18 20.64 12.46L18.74 13.1C17.1 13.64 16 15.16 16 16.88V36C16 38.2 17.8 40 20 40H34C36.2 40 38 38.2 38 36V16.88C38 15.16 36.9 13.64 35.26 13.08ZM26 4H28V6H26V4ZM20 16.88L21.9 16.24C24.36 15.44 26 13.14 26 10.56V10H28V10.56C28 13.14 29.64 15.44 32.1 16.26L34 16.88V20H20V16.88ZM34 36H20V32H34V36Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs);
export default __webpack_public_path__ + "static/media/cs.a228a2a6a74dc02dd519a9d619aaa2a3.svg";
export { ForwardRef as ReactComponent };